/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Privacy_TitleInputs */



/**
* | output |
* | --- |
* | "Privacy Policy" |
*
* @param {Legal_Privacy_TitleInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const legal_privacy_title = /** @type {((inputs?: Legal_Privacy_TitleInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Privacy_TitleInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Политика конфиденциальности")
	return /** @type {LocalizedString} */ ("Privacy Policy")
});